var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Modelo Memorial Descritivo", width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "padding" }, [
          _c("span", [
            _vm._v(
              "Partindo do marco XXX-X-XXXX, de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue confrontando"
            )
          ]),
          _vm._v(
            " com NOME, com a seguinte distância XXXX m e azimute plano XXX°XX'XX\" até o marco XXX-X-XXXX,\n de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue confrontando com NOME, com a seguinte distância\n XXXX m e azimute plano XXX°XX'XX\" até o marco XXX-X-XXXX, de coordenada N = XXXXXXXm e E = XXXXXXXm; deste,\n segue confrontando com NOME, com a seguinte distância XXXX m e azimute plano XXX°XX'XX\" até o marco XXX-X-XXXX,\n de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue confrontando com NOME, com a seguinte distância XXXX m e\n azimute plano XXX°XX'XX\" até o marco XXX-X-XXXX, de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue confrontando com NOME,\n com a seguinte distância XXXX m e azimute plano XXX°XX'XX\" m até o marco XXX-X-XXXX, ponto inicial da descrição deste perímetro.\n Todas as coordenadas aqui descritas estão georreferenciadas ao Sistema Geodésico Brasileiro, a partir do marco XXX-X-XXXX, de coordenada\n N = XXXXXXXm e E = XXXXXXXm, e encontram-se representadas no Sistema U T M, referenciadas ao Meridiano Central nº 45°00', fuso -23, tendo\n como datum o SIRGAS2000. Todos os azimutes e distâncias, área e perímetro foram calculados no plano de projeção U T M."
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16ac90ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ac90ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalModeloMemorial.vue
// module id = null
// module chunks = 